// extracted by mini-css-extract-plugin
export default {"btn":"TimerComponent_btn__ddJvs"};